/*jshint esversion: 8 */
import { fetchPost } from './RequestHandler';

// 缓存登陆
const signinWithToken = async ( token ) => {
  const rst = await fetchPost('/web_system_operation/signinWithToken', { token });
  return rst;
};

// 查询所有用户
const getAllUsers = async (data) => {
  const rst = await fetchPost('/web_system_operation/getAllUsers', { data });
  return rst;
};

// 新增用户
const addUser = async (data) => {
  const rst = await fetchPost('/web_system_operation/addUser', { data });
  return rst;
};

// 修改我的信息
const updateMyInfo = async (data) => {
  const rst = await fetchPost('/web_system_operation/updateMyInfo', { data });
  return rst;
};

// 修改用户
const updateUser = async (data) => {
  const rst = await fetchPost('/web_system_operation/updateUser', { data });
  return rst;
};

// 删除用户
const deleteUser = async (data) => {
  const rst = await fetchPost('/web_system_operation/deleteUser', { data });
  return rst;
};


// 获得当前用户的权限信息



// 查询所有角色类型
const getAllRoles = async (data) => {
  const rst = await fetchPost('/web_system_operation/getAllRoles', { data });
  return rst;
};

// 增加角色类型
const addRole = async (data) => {
  const rst = await fetchPost('/web_system_operation/addRole', { data });
  return rst;
};

// 更新角色类型信息（不包含权限）
const updateRoleInfo = async (data) => {
  const rst = await fetchPost('/web_system_operation/updateRoleInfo', { data });
  return rst;
};


// 删除角色类型
const deleteRole = async (data) => {
  const rst = await fetchPost('/web_system_operation/deleteRole', { data });
  return rst;
};

// 查询角色类型权限
const getRolePrivilege = async (data) => {
  const rst = await fetchPost('/web_system_operation/getRolePrivilege', { data });
  return rst;
};


// 更新角色的权限
const updateRolePrivilege = async (data) => {
  const rst = await fetchPost('/web_system_operation/updateRolePrivilege', { data });
  return rst;
};


// 设置角色类型权限

export {
  signinWithToken,
  getAllUsers,
  addUser,
  updateUser,
  deleteUser,
  addRole,
  getAllRoles,
  deleteRole,
  updateRoleInfo,
  getRolePrivilege,
  updateRolePrivilege,
  updateMyInfo,
};
